import React from 'react'

import { Text } from '@chakra-ui/react'
import { Colors } from '@qirapagos/lib/theme'
import { formatDateWithMonth } from '@qirapagos/lib/utils/common'
import {
  BoxContainer,
  BoxIcon,
  BoxLeftInfo,
  BoxLeftText,
  BoxRightInfo,
  BoxRightText,
  CancelText,
  PendingText,
  TransferOwner
} from './styles'
import { getInfo, TypeMovementsActivity } from './types'
import { ActivityMovement } from 'store/activity/types'
import { capitalizeNames } from 'utils/common'
import { MovementStatus } from '../MovementItem/constants'
import TransferPending from '@qirapagos/lib/assets/svg/TransferPending'
import RescuePending from '@qirapagos/lib/assets/svg/RescuePending'

interface Props {
  activity: ActivityMovement
}

enum TransferActions {
  SENT = 'Enviaste'
}

const ActivityItem: React.FC<Props> = ({ activity }) => {
  const isTransfer =
    activity.movementType === TypeMovementsActivity.MOVEMENT_TRANSFER_DEBIT ||
    activity.movementType === TypeMovementsActivity.MOVEMENT_TRANSFER_CREDIT ||
    activity.movementType === TypeMovementsActivity.DEBIT_TRANSFER_FAILED ||
    activity.movementType === TypeMovementsActivity.DEBIT_REVERSED ||
    activity.movementType === TypeMovementsActivity.CREDIT_REVERSED ||
    activity.movementType === TypeMovementsActivity.ADJUSTMENT_BALANCE_CREDIT ||
    activity.movementType === TypeMovementsActivity.ADJUSTMENT_BALANCE_DEBIT ||
    activity.movementType === TypeMovementsActivity.PERFORMANCE

  const isDebit =
    activity.movementType === TypeMovementsActivity.MOVEMENT_TRANSFER_DEBIT ||
    activity.movementType === TypeMovementsActivity.DEBIT_TRANSFER_FAILED ||
    activity.movementType === TypeMovementsActivity.DEBIT_REVERSED ||
    activity.movementType === TypeMovementsActivity.ADJUSTMENT_BALANCE_DEBIT

  const isQuota =
    activity.movementType === TypeMovementsActivity.QUOTA_AWARDED ||
    activity.movementType === TypeMovementsActivity.QUOTA_CANCELED ||
    activity.movementType === TypeMovementsActivity.QUOTA_REJECTED ||
    activity.movementType === TypeMovementsActivity.QUOTA_REQUIRED

  const amount = isQuota
    ? `${activity.amount}TT`
    : `$${getInfo(activity).amount}`

  const activityFormatted = getInfo(activity)

  const { status } = activity

  const isCancel = status === MovementStatus.REJECTED

  const isPending =
    status === MovementStatus.PENDING ||
    status === MovementStatus.UNKNOWN_FOREVER

  let icon

  if (isPending) {
    if (
      activity.movementType === TypeMovementsActivity.MOVEMENT_TRANSFER_CREDIT
    ) {
      icon = <RescuePending />
    } else {
      icon = <TransferPending />
    }
  } else {
    icon = activityFormatted.icon
  }

  const title = status === 4 ? 'Operación pendiente' : activityFormatted.title

  return (
    <BoxContainer>
      <BoxLeftInfo>
        <BoxIcon>{icon}</BoxIcon>

        <BoxLeftText>
          <Text fontWeight={600} fontSize={{ md: '14px', lg: '16px' }}>
            {title}
          </Text>
          {isCancel && <CancelText>Cancelado</CancelText>}
          {isPending && status !== 4 && <PendingText>Pendiente</PendingText>}
          <Text fontWeight={400} fontSize="14px">
            {amount}
          </Text>
        </BoxLeftText>
      </BoxLeftInfo>
      <BoxRightInfo>
        <BoxRightText>
          <Text
            fontWeight={400}
            fontSize="14px"
            color={Colors.gray}
            lineHeight="12px"
            mb={2}
            alignSelf="center"
          >
            {formatDateWithMonth(activityFormatted.date?.toString() ?? '')}
          </Text>
          {isTransfer && (
            <TransferOwner>
              {isDebit ? 'A ' : 'De '}
              {capitalizeNames(activityFormatted.owner ?? '')}
            </TransferOwner>
          )}
        </BoxRightText>
      </BoxRightInfo>
    </BoxContainer>
  )
}

export default ActivityItem
